import {
  nestjsPostPutPatchRefrence,
  NestjsGetListPageRequest,
} from 'nestjs-model-utility';
import { SystemConfigModel } from 'src/domains/site-managment/model/system-config/system-config.model';
import { SystemConfigFilterApiRoute } from 'src/domains/site-managment/app/api-routes/system-config/system-config-filter.api';
import { SystemConfigApiRoute } from 'src/domains/site-managment/app/api-routes/system-config/system-config.api';

export namespace SystemConfigRequest {
  // To avoid caching from pulic configs, cache is set to false
  export class List extends NestjsGetListPageRequest<
    SystemConfigModel.Index,
    false,
    typeof SystemConfigFilterApiRoute
  > {
    _api = SystemConfigFilterApiRoute;
    cache: false = false;
  }
  export class Edit extends nestjsPostPutPatchRefrence<
    SystemConfigModel.Full,
    'put',
    SystemConfigModel.Full
  > {
    _api = SystemConfigApiRoute;
    _method: 'put' = 'put';
  }
}
